export default "__VITE_ASSET__X4L5$8Bd__"